import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, title: String, text: String, mediaUrl: String, mediaType: String }

  async share() {
    // Try sharing media file first (image/video to WhatsApp)
    if (this.hasMediaUrlValue && this.mediaUrlValue && navigator.canShare) {
      try {
        const file = await this._fetchMediaFile()
        if (file) {
          const shareData = {
            title: this.hasTitleValue ? this.titleValue : document.title,
            text: this.hasTextValue ? this.textValue : "",
            url: this.urlValue,
            files: [file]
          }
          if (navigator.canShare(shareData)) {
            await navigator.share(shareData)
            return
          }
        }
      } catch (err) {
        if (err.name === "AbortError") return
        // Fall through to URL share
      }
    }

    // Fallback: share URL only
    const shareData = {
      title: this.hasTitleValue ? this.titleValue : document.title,
      text: this.hasTextValue ? this.textValue : "",
      url: this.urlValue
    }

    if (navigator.share) {
      try {
        await navigator.share(shareData)
      } catch (err) {
        if (err.name !== "AbortError") {
          this.fallbackCopy(shareData.url)
        }
      }
    } else {
      this.fallbackCopy(shareData.url)
    }
  }

  async _fetchMediaFile() {
    try {
      const response = await fetch(this.mediaUrlValue)
      const blob = await response.blob()
      const type = this.hasMediaTypeValue ? this.mediaTypeValue : blob.type
      const ext = type.includes("video") ? "mp4" : (type.includes("png") ? "png" : "jpg")
      const filename = `opinaki-post.${ext}`
      return new File([blob], filename, { type })
    } catch {
      return null
    }
  }

  fallbackCopy(url) {
    navigator.clipboard.writeText(url)
    const span = this.element.querySelector("span")
    if (span) {
      const original = span.textContent
      span.textContent = "Link copiado!"
      setTimeout(() => { span.textContent = original }, 2000)
    }
  }
}
